<template>
    <span>
        <svg 
            v-if="name == 'peppol'" 
            version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="500.000000pt" height="500.000000pt" viewBox="0 0 500.000000 500.000000"
            preserveAspectRatio="xMidYMid meet" :style="sizeStyle">

            <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
                :fill="color" stroke="none">
                <path d="M2053 4950 c-80 -36 -156 -136 -207 -272 -23 -61 -76 -262 -76 -290
                0 -26 -18 -39 -100 -73 -195 -81 -414 -229 -566 -382 -117 -119 -117 -119
                -257 -81 -68 19 -108 23 -232 23 -144 0 -152 -1 -207 -28 -120 -59 -164 -136
                -156 -270 9 -133 81 -281 230 -465 37 -46 68 -92 68 -100 0 -16 -48 -347 -56
                -389 -3 -15 -22 -32 -57 -49 -145 -74 -330 -244 -385 -355 -26 -53 -32 -77
                -32 -130 0 -187 164 -300 499 -345 63 -8 118 -17 123 -20 4 -3 32 -55 61 -117
                141 -295 369 -558 655 -755 201 -139 508 -267 732 -306 52 -9 105 -19 117 -21
                16 -4 37 -36 82 -127 214 -437 501 -513 686 -183 40 71 101 249 111 322 8 62
                18 73 109 108 119 47 265 124 370 196 56 37 112 72 125 77 17 6 59 -1 154 -26
                118 -31 145 -35 271 -36 124 -1 145 1 187 21 104 48 179 153 178 251 -1 116
                -64 259 -183 421 -53 71 -52 70 -6 162 15 30 43 101 62 156 30 86 42 129 73
                258 19 81 34 265 34 410 l0 170 83 55 c114 76 245 208 285 289 26 53 32 76 32
                131 0 197 -181 314 -540 349 -63 7 -123 14 -132 17 -9 3 -46 46 -82 97 -303
                427 -739 708 -1262 812 -69 14 -140 25 -158 25 -41 0 -54 14 -103 116 -81 166
                -194 303 -289 349 -57 28 -185 31 -241 5z m186 -248 c65 -68 145 -188 138
                -206 -5 -11 -20 -16 -49 -16 -24 0 -101 -10 -171 -21 -82 -14 -132 -18 -138
                -12 -21 21 58 221 109 276 36 38 59 34 111 -21z m571 -471 c492 -103 894 -380
                1165 -806 86 -135 151 -290 211 -499 l28 -99 -25 -20 c-36 -31 -357 -184 -496
                -237 -92 -36 -93 -36 -143 -10 -121 62 -252 37 -318 -60 -12 -18 -25 -45 -29
                -59 -3 -14 -13 -34 -21 -44 -34 -38 -665 -216 -769 -217 -40 0 -44 3 -78 55
                -61 92 -153 157 -260 185 -27 7 -55 17 -61 22 -22 16 -38 140 -59 441 -9 135
                -12 225 -6 235 5 9 21 28 36 42 45 42 75 112 75 175 0 67 -15 98 -80 171 l-50
                54 0 113 c0 167 28 499 43 515 11 11 214 51 327 66 19 2 118 3 220 1 143 -2
                209 -7 290 -24z m-1087 -197 c-1 -27 -5 -143 -9 -258 l-7 -209 -48 -53 c-70
                -77 -83 -108 -83 -184 1 -83 28 -139 89 -182 53 -37 50 -26 65 -288 7 -107 16
                -226 21 -265 5 -38 12 -98 16 -132 l6 -61 -39 -24 c-85 -53 -85 -53 -285 108
                -310 249 -613 531 -626 582 -7 28 14 86 80 217 155 311 413 584 712 754 49 28
                94 50 100 48 5 -2 9 -26 8 -53z m-930 -395 c20 -5 37 -16 37 -24 0 -7 -23 -51
                -52 -97 -28 -46 -66 -116 -84 -155 -43 -93 -60 -95 -110 -17 -55 85 -94 176
                -100 230 -7 58 2 70 61 77 54 6 201 -3 248 -14z m3657 -355 c36 -8 90 -27 120
                -42 67 -33 76 -62 37 -121 -26 -40 -118 -134 -155 -158 -28 -20 -47 -6 -56 42
                -7 34 -55 185 -77 241 -7 17 -9 39 -6 48 7 19 6 19 137 -10z m-3559 -607 c146
                -145 272 -254 464 -401 77 -59 145 -116 151 -127 12 -22 -5 -132 -24 -151 -12
                -12 -416 -47 -554 -48 -81 0 -110 4 -121 15 -16 15 -47 140 -69 275 -14 81
                -17 459 -4 523 4 20 13 37 20 37 7 0 69 -55 137 -123z m3344 -138 c4 -12 4
                -71 0 -133 -25 -430 -177 -782 -483 -1123 -94 -105 -110 -109 -219 -58 -43 20
                -127 57 -188 83 -224 93 -766 382 -899 479 -47 34 -48 36 -42 76 11 70 33 90
                114 104 125 21 463 113 636 172 75 27 107 26 159 -1 32 -17 59 -22 117 -23 71
                0 79 2 125 35 35 25 59 52 78 90 15 30 35 62 45 72 9 9 77 41 150 72 73 31
                186 83 250 116 64 32 125 59 134 59 9 1 20 -8 23 -20z m-3719 -301 c6 -54 20
                -131 29 -173 13 -53 15 -79 8 -86 -30 -30 -268 44 -297 92 -20 34 5 74 105
                172 132 128 140 128 155 -5z m1505 -30 c65 -22 116 -65 144 -122 35 -73 41
                -121 21 -189 -31 -108 -115 -167 -236 -167 -54 0 -74 5 -118 30 -115 66 -154
                221 -86 337 55 95 178 144 275 111z m-454 -491 c61 -102 146 -163 283 -203 88
                -25 77 -5 136 -254 20 -85 59 -222 85 -305 27 -82 49 -154 49 -161 0 -21 -24
                -22 -98 -3 -167 42 -423 167 -584 284 -107 78 -266 233 -346 339 -92 121 -182
                268 -182 296 0 18 6 20 57 20 64 0 442 29 458 35 6 2 33 4 60 4 l50 1 32 -53z
                m793 -141 c240 -150 350 -210 673 -370 114 -57 246 -116 292 -132 135 -46 128
                -59 -90 -165 -246 -118 -499 -179 -751 -179 -121 0 -110 -14 -184 230 -18 58
                -38 123 -45 145 -34 104 -105 412 -100 432 7 28 81 73 120 73 18 0 54 -15 85
                -34z m1816 -234 c22 -33 67 -144 78 -193 13 -60 -57 -84 -209 -73 -159 12
                -166 24 -72 129 34 39 79 94 101 123 45 62 68 65 102 14z m-1323 -834 c-2 -33
                -68 -191 -95 -230 -25 -36 -61 -45 -93 -24 -51 33 -184 224 -171 245 3 4 59
                12 123 15 65 4 134 11 153 16 19 5 46 8 60 7 21 -2 25 -7 23 -29z"/>
            </g>
        </svg>

        <svg
            v-if="name == 'aeat'" 
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" :style="sizeStyle">
            <path d="M0 0h150v150H0V0z" fill="none"/><path fill="#00549a" d="M141.9 130.2L76.1 17.8H22.8l66.7 112.4z"/>
            <path d="M23.3 121.4l6.5 10.1c57.8-3.3 104.2-50.6 108.6-83.7l-7.3-9.1c-9.4 45.1-67.5 80-107.8 82.7z" fill="#ecba0b"/>
            <path d="M38.9 59.1L44.3 70c-6.4 5.9-9.5 9.9-14 17.3-6 10-8.4 16.5-10.3 28l-8-13c2.6-8.3 4.7-12.9 9-20.5 5.7-9.6 9.8-14.8 17.9-22.7z" fill="#d12920"/>
        </svg>

        <svg
            v-if="name == 'aeat-red'" 
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" :style="sizeStyle">
            <path d="M0 0h150v150H0V0z" fill="none"/><path fill="#c94c4c" d="M141.9 130.2L76.1 17.8H22.8l66.7 112.4z"/>
            <path d="M23.3 121.4l6.5 10.1c57.8-3.3 104.2-50.6 108.6-83.7l-7.3-9.1c-9.4 45.1-67.5 80-107.8 82.7z" fill="#eea29a"/>
            <path d="M38.9 59.1L44.3 70c-6.4 5.9-9.5 9.9-14 17.3-6 10-8.4 16.5-10.3 28l-8-13c2.6-8.3 4.7-12.9 9-20.5 5.7-9.6 9.8-14.8 17.9-22.7z" fill="#f7786b"/>
        </svg>
    </span>
</template>

<script>
export default {
    name: "CustomIcon",
    props: {
        name: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            default: 24
        },
        height: {
            type: Number,
            default: 24
        },
        color: {
            type: String,
            default: "#000000"
        }
    },
    computed: {
        sizeStyle() {
            return `width: ${this.width}px; height: ${this.height}px;`
        }
    }
}
</script>